"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PAGE = void 0;
var history_1 = require("@pbl/pbl-react-core/lib/models/history");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var TimeUtil_1 = require("@pbl/pbl-react-core/lib/utils/TimeUtil");
var EInstantDetailDialog_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/history/EInstantDetailDialog"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var page_container_1 = require("@pbl/pbl-react-web-components/lib/page-container");
var lodash_1 = __importDefault(require("lodash"));
var React = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var constants_1 = __importDefault(require("../../config/constants"));
var actions_1 = require("../../redux/reducers/app/actions");
var actions_2 = require("../../redux/reducers/authentication/actions");
var actions_3 = require("../../redux/reducers/draws/actions");
var actions_4 = require("../../redux/reducers/loyalty/actions");
var useActivities_1 = __importDefault(require("../../shared/hooks/providers/useActivities"));
var useDigitalRevealGame_1 = __importDefault(require("../../shared/hooks/providers/useDigitalRevealGame"));
var useEInstants_1 = __importDefault(require("../../shared/hooks/providers/useEInstants"));
var useHistoryDraws_1 = __importDefault(require("../../shared/hooks/providers/useHistoryDraws"));
var usePendingPointsData_1 = __importDefault(require("../../shared/hooks/providers/usePendingPointsData"));
var usePointsBalanceData_1 = __importDefault(require("../../shared/hooks/providers/usePointsBalanceData"));
var useRewards_1 = __importDefault(require("../../shared/hooks/providers/useRewards"));
var useTicketEntriesHistory_1 = __importDefault(require("../../shared/hooks/providers/useTicketEntriesHistory"));
var framework_1 = require("../../widgets/framework");
var History_1 = __importDefault(require("./components/History"));
exports.DEFAULT_PAGE = 0;
var perPageOptions = [10, 25, 50, 75, 100];
var HistoryScreen = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var _m = _a.showHeadingTitle, showHeadingTitle = _m === void 0 ? true : _m, _o = _a.isNewVersion, isNewVersion = _o === void 0 ? true : _o, _p = _a.showEInstant, showEInstant = _p === void 0 ? true : _p, _q = _a.showContainerTitle, showContainerTitle = _q === void 0 ? true : _q, showDigitalReveal = _a.showDigitalReveal, showEinstantTabFirst = _a.showEinstantTabFirst, isTitleH1 = _a.isTitleH1, isAlternateHeadingStyle = _a.isAlternateHeadingStyle;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _r = (0, react_redux_1.useSelector)(function (rootState) { return (__assign(__assign({}, rootState.drawDetail), rootState.authentication)); }), drawPrizes = _r.drawPrizes, drawPrizeContentRetrieved = _r.drawPrizeContentRetrieved, drawPrizesWithWinners = _r.drawPrizesWithWinners, isLoggedIn = _r.isAuthenticated, authenticating = _r.authenticating;
    var initialState = {
        loadingWidget: true,
        showWinnerDialog: false,
        showPrizesDialog: false,
        draw: {},
        selectedHistoryItem: null,
        drawEntriesHistory: null,
        selectedEInstantGroup: null,
        openEInstantsGroupDialog: false,
        loadingEInstantDetails: false,
        eInstantHistoryDetails: new history_1.HistoryEInstantsList(),
        page: {}
    };
    function reducer(reducerState, action) {
        return __assign(__assign({}, reducerState), action);
    }
    var _s = React.useReducer(reducer, initialState), state = _s[0], setState = _s[1];
    var _t = React.useState(false), shouldRefreshHistoryData = _t[0], setShouldRefreshHistoryData = _t[1];
    var historyDraws = (0, useHistoryDraws_1.default)(isLoggedIn);
    var historyTicketEntries = (0, useTicketEntriesHistory_1.default)(isLoggedIn);
    var historyActivities = (0, useActivities_1.default)(isLoggedIn, constants_1.default.SECOND_CHANCE_ONLY);
    var historyRewards = (0, useRewards_1.default)(isLoggedIn, constants_1.default.SECOND_CHANCE_ONLY);
    var historyEInstants = (0, useEInstants_1.default)(showEInstant && isLoggedIn);
    var historyDigitalReveal = (0, useDigitalRevealGame_1.default)(isLoggedIn);
    var _u = (0, usePointsBalanceData_1.default)(isLoggedIn, constants_1.default.SECOND_CHANCE_ONLY), loyaltyBalance = _u.loyaltyBalance, fetchPointsData = _u.fetchPointsData;
    var _v = (0, usePendingPointsData_1.default)(isLoggedIn, constants_1.default.SECOND_CHANCE_ONLY, constants_1.default.SHOW_PENDING_POINTS_ON_HISTORY_PAGE), pendingBalance = _v.pendingBalance, fetchPendingPointsData = _v.fetchPendingPointsData;
    var search = window.location.search;
    var params = new URLSearchParams(search);
    var t = (0, react_i18next_1.useTranslation)().t;
    var identifier = React.useMemo(function () {
        var _a;
        return constants_1.default.SECOND_CHANCE_ONLY
            ? 'tickets'
            : (_a = params.get('selectedQuickLink')) !== null && _a !== void 0 ? _a : 'history.activities';
    }, [params, constants_1.default.SECOND_CHANCE_ONLY]);
    var spinnerAdditionalProps = constants_1.default.HISTORY_WIDGET_PERSIST_SPINNER === true ? { persistSpinner: true } : {};
    React.useEffect(function () {
        dispatch((0, actions_2.isAuthenticated)());
        return function () {
            dispatch((0, actions_4.resetState)());
            dispatch((0, actions_1.clearMessages)());
        };
    }, []);
    React.useEffect(function () {
        if (!isLoggedIn && !authenticating) {
            setState({ loadingWidget: true });
            redirectToLogin();
        }
        else if (isLoggedIn && !authenticating) {
            getData();
            if (showEInstant) {
                onEInstantsDetailDialogPageChange(0, 0);
            }
        }
    }, [isLoggedIn, authenticating, shouldRefreshHistoryData]);
    var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var promises;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    promises = [
                        historyTicketEntries.fetchData({ pageNumber: exports.DEFAULT_PAGE }),
                        historyDraws.fetchData(exports.DEFAULT_PAGE)
                    ];
                    if (!constants_1.default.SECOND_CHANCE_ONLY) {
                        promises.push(historyActivities.fetchData(exports.DEFAULT_PAGE), historyRewards.fetchData(exports.DEFAULT_PAGE), fetchPointsData(), fetchPendingPointsData());
                    }
                    if (showDigitalReveal) {
                        promises.push(historyDigitalReveal.fetchData(exports.DEFAULT_PAGE));
                    }
                    if (showEInstant) {
                        promises.push(historyEInstants.fetchData(exports.DEFAULT_PAGE));
                    }
                    return [4, Promise.all(promises)];
                case 1:
                    _a.sent();
                    setState({ loadingWidget: false });
                    return [2];
            }
        });
    }); };
    var hideWinnersDialog = function () {
        setState({ showWinnerDialog: false });
    };
    var openWinnersPopup = function (selectedDraw) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch((0, actions_3.fetchDrawPrizesWithContent)(selectedDraw.id));
                    return [4, services_1.PromotionsService.fetchSecondChanceDrawEntries(selectedDraw.id)];
                case 1:
                    response = _a.sent();
                    setState({ drawEntriesHistory: lodash_1.default.reverse(lodash_1.default.orderBy(response, [function (o) { return o.entryTime; }], ['asc'])) });
                    return [3, 3];
                case 2:
                    e_1 = _a.sent();
                    dispatch((0, actions_1.showMessageBar)({ message: e_1.message, type: 'error' }));
                    return [3, 3];
                case 3:
                    setState({ showWinnerDialog: true, draw: selectedDraw });
                    return [2];
            }
        });
    }); };
    var onViewPrizeDetailsAndImagesClicked = function () {
        setState({ showWinnerDialog: false, showPrizesDialog: true });
    };
    var setSelectedTicketEntry = function (ticket) { return __awaiter(void 0, void 0, void 0, function () {
        var drawsResponse, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, services_1.HistoryService.fetchDrawsByIds(ticket)];
                case 1:
                    drawsResponse = _a.sent();
                    setState({ selectedHistoryItem: drawsResponse });
                    return [3, 3];
                case 2:
                    e_2 = _a.sent();
                    dispatch((0, actions_1.showMessageBar)({ message: e_2.message, type: 'error' }));
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var redirectToLogin = function () {
        framework_1.GoFwInternalInstance.onHostLogin();
    };
    var closePrizesDialog = function () { return setState({ showPrizesDialog: false }); };
    var onEInstantsDetailDialogPageChange = function (pageNumber, size) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedEInstantGroup, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selectedEInstantGroup = state.selectedEInstantGroup;
                    if (!(selectedEInstantGroup === null || selectedEInstantGroup === void 0 ? void 0 : selectedEInstantGroup.gameId)) return [3, 2];
                    setState({ loadingEInstantDetails: true });
                    return [4, services_1.HistoryService.getEinstantBetHistoryDetails(selectedEInstantGroup.gameId, pageNumber, size)];
                case 1:
                    response = _a.sent();
                    if (response) {
                        setState({ eInstantHistoryDetails: response.data || new history_1.HistoryEInstantsList() });
                        if (response.page) {
                            setState({ page: response.page });
                        }
                    }
                    setState({ loadingEInstantDetails: false });
                    _a.label = 2;
                case 2: return [2];
            }
        });
    }); };
    var hideEInstantsGroupDialog = function () {
        setState({
            openEInstantsGroupDialog: false,
            eInstantHistoryDetails: new history_1.HistoryEInstantsList(),
            page: {}
        });
    };
    var openEInstantsDetailDialog = function (einstantsGrouped) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setState({ selectedEInstantGroup: einstantsGrouped, openEInstantsGroupDialog: true });
            return [2];
        });
    }); };
    var refreshHistoryData = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setTimeout(function () {
                setShouldRefreshHistoryData(function (prev) { return !prev; });
            }, 2000);
            return [2];
        });
    }); };
    return (React.createElement(page_container_1.Container, { pageTitle: 'History', title: showContainerTitle && (React.createElement(package_1.Title, { title: t('history.history', 'History'), titleColor: 'textPrimary', isTitleH1: isTitleH1, isAlternateHeadingStyle: isAlternateHeadingStyle })) }, state.loadingWidget ? (React.createElement(package_1.AppSpinner, __assign({ label: 'Loading...', customStyles: {
            backgroundColor: 'transparent'
        } }, spinnerAdditionalProps))) : (React.createElement(React.Fragment, null,
        React.createElement(package_1.WinnersDialog, { title: (_c = (_b = state.draw) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '', open: state.showWinnerDialog, drawEndDate: (_e = (0, TimeUtil_1.formatLongMonthDayCommaYear)((_d = state.draw) === null || _d === void 0 ? void 0 : _d.end)) !== null && _e !== void 0 ? _e : 'TBD', drawDate: (_g = (0, TimeUtil_1.formatLongMonthDayCommaYear)((_f = state.draw) === null || _f === void 0 ? void 0 : _f.draw)) !== null && _g !== void 0 ? _g : 'TBD', drawPrizesWithWinners: drawPrizesWithWinners, onClose: hideWinnersDialog, drawStartDate: (_j = (0, TimeUtil_1.formatLongMonthDayCommaYear)((_h = state.draw) === null || _h === void 0 ? void 0 : _h.start)) !== null && _j !== void 0 ? _j : '', onViewPrizeDetailsClicked: onViewPrizeDetailsAndImagesClicked, isSweepStake: false, secondChanceTicketHistory: state.drawEntriesHistory, entries: state.draw.totalPrizeAmount, drawName: (_l = (_k = state.draw) === null || _k === void 0 ? void 0 : _k.name) !== null && _l !== void 0 ? _l : '' }),
        React.createElement(package_1.PrizesDialog, { title: state.draw ? state.draw.name + ' Prize Details' : '', open: state.showPrizesDialog, onClose: closePrizesDialog, drawPrizeContentRetrieved: drawPrizeContentRetrieved, drawPrizes: drawPrizes }),
        showEInstant && (React.createElement(EInstantDetailDialog_1.default, { open: state.openEInstantsGroupDialog, onClose: hideEInstantsGroupDialog, historyEInstants: state.eInstantHistoryDetails.map(function (historyRecord) {
                var _a;
                return (__assign(__assign({}, historyRecord), { gameImageUrl: (_a = state.selectedEInstantGroup) === null || _a === void 0 ? void 0 : _a.gameImageUrl }));
            }), historyEInstantsPage: state.page, onPageDataChange: onEInstantsDetailDialogPageChange, pageOptions: perPageOptions })),
        React.createElement(History_1.default, { identifier: identifier, loading: historyDraws.loading || historyTicketEntries.loading, historyTicketEntries: historyTicketEntries, historyDraws: historyDraws, setSelectedHistoryItem: setSelectedTicketEntry, selectedHistoryItem: state.selectedHistoryItem, HISTORY_ITEMS_PER_PAGE: constants_1.default.HISTORY_ITEMS_PER_PAGE, navigateToDrawDetails: openWinnersPopup, showHeadingTitle: showHeadingTitle, showEInstant: showEInstant, showDigitalReveal: showDigitalReveal, historyActivities: historyActivities, historyRewards: historyRewards, historyEInstants: historyEInstants, historyDigitalReveal: historyDigitalReveal, reedemablePoints: loyaltyBalance, pendingPoints: pendingBalance, isNewVersion: isNewVersion, navigateToEInstantsHistoryDetails: openEInstantsDetailDialog, showEinstantTabFirst: showEinstantTabFirst, refreshHistoryData: refreshHistoryData, isTitleH1: isTitleH1, isAlternateHeadingStyle: isAlternateHeadingStyle })))));
};
exports.default = HistoryScreen;
//# sourceMappingURL=index.js.map